// extracted by mini-css-extract-plugin
export var bodySections = "_9p-8";
export var gray = "_9p-7";
export var green = "_9p-4";
export var iconContainer = "_9p-9";
export var iconWidgetContainer = "_9p-1";
export var phoneIcon = "_9p-2";
export var red = "_9p-5";
export var statusDot = "_9p-3";
export var widgetContainer = "_9p-0";
export var yellow = "_9p-6";